import React from "react";
import { object, number } from "prop-types";

import BigNumber from "../../../atoms/BigNumber";
import NewsHeadline from "../../../atoms/NewsHeadline";
import Excerpt from "../../../atoms/Excerpt";
import StoryMetaData from "../../../molecules/StoryMetaData";
import CardImage from "../../../atoms/CardImage";

import { getExcerpt } from "../../../utils/utils";
import { useDevice } from "../../../utils/react-utils";

import "./organism.m.css";

const Organism = ({ story, headlineNumber }) => {
  const { mobile } = useDevice();

  const excerpt = getExcerpt(story);

  return (
    <div styleName="wrapper">
      <div styleName="item-left">
        <BigNumber headlineNumber={headlineNumber} className="big-number" />
        <div>
          <NewsHeadline iconEnd={false} story={story} showSponsor={false} />
          {!mobile && (
            <>
              <Excerpt excerpt={excerpt} url={story.url} />
              <StoryMetaData story={story} />
            </>
          )}
        </div>
      </div>
      <div styleName="item-right">
        <CardImage
          className="card-with-image-zoom"
          story={story}
          aspectRatio={[3, 2]}
          imageType="image3x2"
          linkEnable={true}
          widths={[350, 350, 450]}
        />
      </div>
    </div>
  );
};

Organism.propTypes = {
  story: object,
  headlineNumber: number,
};

export default Organism;
